export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calidad final de los contenedores"])},
          "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resumen de la calidad final de los contenedores"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver detalles"])},
          "agro_exporter_process": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proceso"])},
          "total_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["# contenedores"])}
        }
      }
    }
  })
}